var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextHSix = function SvgIconTextHSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.25a1 1 0 0 1 1 1v4.625h7.75V5.25a1 1 0 1 1 2 0V16.5a1 1 0 1 1-2 0v-4.625H4.75V16.5a1 1 0 1 1-2 0V5.25a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.512 8.516a1 1 0 0 1 .347 1.371l-1.34 2.248a3.625 3.625 0 1 1-3.284 1.602l2.906-4.874a1 1 0 0 1 1.371-.347m-2.705 6.485a1.625 1.625 0 1 0 .112-.185l-.079.134z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTextHSix;